import { SimpleOutlineAssemblySystem, SimpleOutlineModelSystem, SimpleOutlineSelectedSystem, } from "@inter-ikea-core/core-toolbox";
import { StandardSelectionSystem } from "@inter-ikea-core/core";
export { AttachmentsSystem } from "./AttachmentsSystem";
export { CrossBraceCalculationSystem } from "./CrossBraceCalculationSystem";
export { EntityReplacementSystem } from "./EntityReplacementSystem";
export { HandleSectionAttachmentSystem } from "./HandleSectionAttachmentSystem";
export { HandleSideUnitRemovalSystem } from "./HandleSideUnitRemovalSystem";
export { RefreshSectionsAlignmentsOnDragSystem } from "./RefreshSectionsAlignmentsOnDragSystem";
export { BlockConnectionHoleSystem } from "./BlockConnectionHoleSystem";
export { ValidateDragSystem } from "./ValidateDragSystem";
export { StabilitySystem } from "./StabilitySystem";
export { InteractableSectionSystem } from "./InteractiveSectionSystem";
const selectionFeature = () => ({
    outlineSelectedSystem: () => new SimpleOutlineSelectedSystem(),
    outlineAssemblySystem: () => new SimpleOutlineAssemblySystem(),
    outlineModelSystem: () => new SimpleOutlineModelSystem(),
    selectionSystem: ({ core }) => new StandardSelectionSystem(core.services.entityManager, core.services.sceneManager),
});
export const defaultSystems = selectionFeature();
